import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgN600Histogram = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 500 500",
	style: { enableBackground: "new 0 0 500 500" },
	xmlSpace: "preserve",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M274.37,343.61h-48.74c-4.78,0-8.66-3.88-8.66-8.66v-169.9c0-4.78,3.88-8.66,8.66-8.66h48.74 c4.78,0,8.66,3.88,8.66,8.66v169.9C283.03,339.73,279.15,343.61,274.37,343.61z M234.29,326.29h31.42V173.71h-31.42V326.29z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M193.25,343.61h-48.74c-4.78,0-8.66-3.88-8.66-8.66v-72.13c0-4.78,3.88-8.66,8.66-8.66h48.74 c4.78,0,8.66,3.88,8.66,8.66v72.13C201.91,339.73,198.04,343.61,193.25,343.61z M153.17,326.29h31.42v-54.8h-31.42V326.29z"
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M355.49,343.61h-48.74c-4.78,0-8.66-3.88-8.66-8.66V211.29c0-4.78,3.88-8.66,8.66-8.66h48.74 c4.78,0,8.66,3.88,8.66,8.66v123.66C364.15,339.73,360.27,343.61,355.49,343.61z M315.41,326.29h31.42V219.95h-31.42V326.29z"
		}) })
	] })]
});
const ForwardRef = forwardRef(SvgN600Histogram);
export { ForwardRef as ReactComponent };
